module.exports = __webpack_public_path__ + "static/img/2.49bd411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/12.18/2.png
// module id = T+Zw
// module chunks = 1